/** The listing of the cards, without filters. */
export const NFC_CARDS_PATH = '/nfc-cards';

/** The screens of one card, by the last segment of their route. */
export type NfcCardScreen = 'saldo' | 'cargas' | 'movimientos';

/**
 * What the listing hands to the screen of a card when it opens it: the listing as it was
 * (filters and page), so going back opens it the same.
 */
export type NfcCardScreenState = { listing: string };

/**
 * The route of one screen of a card.
 *
 * @param cardId The card id
 * @param screen Which screen
 */
export function nfcCardPath(cardId: string, screen: NfcCardScreen): string {
	return `${NFC_CARDS_PATH}/${encodeURIComponent(cardId)}/${screen}`;
}

/**
 * Where the back button of a card screen goes: the listing the screen was opened from, or
 * the bare listing when it was opened any other way (a link, a reload, the old route).
 *
 * @param state The location state the screen was opened with
 */
export function getListingPath(state: unknown): string {
	const listing = (state as Partial<NfcCardScreenState> | null)?.listing;

	// Only the listing itself: the state is not trusted to send anywhere else
	return typeof listing === 'string' && (listing === NFC_CARDS_PATH || listing.startsWith(`${NFC_CARDS_PATH}?`))
		? listing
		: NFC_CARDS_PATH;
}
